import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Postcards  = () => {

  const  servicesFaqData = [
    { 
        question: "What are postcards, and where are they used? ", 
        answer: "Postcards are printed cards designed to send messages, promote products, or convey greetings in a simple yet effective format. They are used in personal communication, corporate branding, and promotional campaigns. Businesses often use postcards for direct mail marketing, event invitations, and seasonal offers. Individuals rely on them for personalised greetings, thank-you notes, and travel updates. The versatility of postcards makes them a popular and impactful tool for both professional and personal use."
    },
    { 
        question: "What are the benefits of custom postcard printing?  ", 
        answer: "Custom postcard printing allows you to create designs that align with your brand, message, or event. Personalisation ensures that your postcards stand out, capturing the attention of recipients. High-quality materials and printing techniques enhance the card’s appearance, making it professional and engaging. Customised postcards can include unique layouts, logos, and branding elements, adding a personal touch to your communication. This level of detail ensures that your postcards effectively convey your message and leave a lasting impression."
    },
    { 
        question: "Can Printingy handle bulk orders for postcard printing?   ", 
        answer: "Printingy specialises in bulk postcard printing, providing cost-effective solutions for large-scale campaigns or events. Bulk printing reduces per-unit costs, making it an economical option for businesses and individuals requiring multiple cards. Advanced printing technology ensures consistent quality across all prints, regardless of order size. With quick turnaround times, we guarantee that your bulk orders are delivered on schedule, meeting your promotional or personal needs. Printingy’s reliable bulk printing services make creating impactful postcards at scale easy."
    },
    { 
        question: "What materials are used for design & printing postcards? ", 
        answer: "Our design & printing postcard services use premium materials such as glossy cardstock, matte paper, and eco-friendly options. Glossy cardstock enhances colours and details, making postcards vibrant and eye-catching. Matte paper provides a smooth, elegant finish suitable for professional branding or formal communication. For environmentally conscious clients, we offer recycled materials that maintain quality while supporting sustainability. These materials ensure the postcards are durable, visually appealing, and suitable for mailing or hand-delivery."
    },
    { 
        question: "What industries and individuals benefit from custom postcard printing services?  ", 
        answer: "Retailers, event organisers, and individuals benefit significantly from custom postcard printing services. Retailers use postcards for direct mail marketing, seasonal promotions, and customer engagement. Event organisers rely on them for invitations, thank-yous, and promotional campaigns. Individuals use postcards for travel updates, personalised greetings, and holiday wishes. Custom postcards are a versatile tool to enhance communication, strengthen relationships, and effectively promote messages. Whether for professional or personal use, postcards add value to any interaction."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing of Postcards');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Custom Postcards Printing Services"
  description="High-quality printing of postcards for personal, corporate, and promotional use. Bulk custom postcard printing, design and printing postcards, and professional solutions."
  keywords="Printing of Postcards,
Custom Postcards Printing,
Design & Printing Postcards,
Postcards Printing,
Bulk Postcards Printing

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Postcards </h1>
              <h2 className="text-muted">Customised postcards for branding, promotions, and personal use     </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Postcards are a timeless and versatile way to connect with customers, clients, and loved ones through personalised messages and visuals. Printingy specialises in Printing Postcards, delivering high-quality postcard printing for personal, corporate, and promotional needs.</p>
          <p>Our services include custom postcard printing tailored to reflect your unique branding or messaging. For a seamless and creative experience, we also offer design and printing postcards with vibrant visuals and professional finishes. Printingy ensures precision, quality, and reliability in every order, whether for marketing campaigns, invitations, or personal greetings.</p>
          
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row>
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Postcards Printing Solutions  </h2>
                <h3 className="large-hed">High-quality, versatile postcards for every purpose  </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Postcards for personal and professional use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk postcard printing with competitive pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customised custom postcard printing tailored to your needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Creative design & printing postcards with premium finishes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-resolution visuals and vibrant colours for a lasting impact.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials are suitable for mailing and long-term use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for businesses, event organisers, and individuals.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/cus-fly-1.jpg" // Path relative to the public folder
                  alt="Professional printing of postcards services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Postcards Delivered On Time  </h2>
            <h3 className="small-hed">Focus on your communication while we handle your postcard printing needs</h3>
            <p>At Printingy, we use state-of-the-art printing techniques and premium materials to deliver exceptional custom postcard printing solutions. Whether for promotional campaigns, customer engagement, or personal greetings, our design and printing postcard services ensure professional and impactful results.
            </p>
            <p>We prioritise efficiency and quality, guaranteeing timely delivery for all bulk and customised orders. Partner with Printingy for reliable and elegant postcard printing solutions.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Postcards;
